import { Controller } from "@hotwired/stimulus";

export default class ChatController extends Controller {
  static targets = ["chatBox", "sendBtn", "actionBtn", "input", "scrollButton"];

  initialize() {
    this.updateVisibleCollapseIcon();
    this.toggleScrollButton = this.toggleScrollButton.bind(this);
  }

  connect() {
    this.chatBoxTarget.addEventListener("scroll", this.toggleScrollButton);
    this.scrollToBottom();
  }

  currentVisibleButton = null;

  disconnect() {
    this.chatBoxTarget.removeEventListener("scroll", this.toggleScrollButton);
    clearTimeout(this.invoiceHighlightTimeout);
    this.highlightedInvoice?.classList.remove("chat-invoice-highlight");
  }

  scrollToInvoice(event) {
    const invoice = this.chatBoxTarget.querySelector(
      `#chat-invoice-${event.params.invoiceId}`,
    );
    if (!invoice) return;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const chatBox = this.chatBoxTarget;
    const top =
      chatBox.scrollTop +
      invoice.getBoundingClientRect().top -
      chatBox.getBoundingClientRect().top -
      chatBox.clientTop -
      16;
    invoice.focus({ preventScroll: true });
    chatBox.scrollTo({
      top: Math.max(0, top),
      behavior: reducedMotion ? "instant" : "smooth",
    });
    chatBox.scrollIntoView({
      block: "nearest",
      behavior: reducedMotion ? "instant" : "smooth",
    });

    clearTimeout(this.invoiceHighlightTimeout);
    this.highlightedInvoice?.classList.remove("chat-invoice-highlight");
    this.highlightedInvoice = invoice;
    invoice.classList.add("chat-invoice-highlight");
    this.invoiceHighlightTimeout = setTimeout(() => {
      invoice.classList.remove("chat-invoice-highlight");
    }, 2500);
  }

  scrollToBottom() {
    this.chatBoxTarget.scrollTo({
      top: this.chatBoxTarget.scrollHeight,
      behavior: "smooth",
    });
  }

  toggleScrollButton() {
    const atBottom =
      this.chatBoxTarget.scrollHeight -
        this.chatBoxTarget.scrollTop -
        this.chatBoxTarget.clientHeight <
      5;

    if (atBottom) {
      this.scrollButtonTarget.classList.add("d-none");
      this.scrollButtonTarget.classList.remove("d-flex");
    } else {
      this.scrollButtonTarget.classList.remove("d-none");
      this.scrollButtonTarget.classList.add("d-flex");
    }
  }

  actionDropdownAppearance(event) {
    const hasText = event.target.value.length > 0;

    if (hasText) {
      if (this.currentVisibleButton === this.sendBtnTarget) return;
      this.switchButtons(
        this.currentVisibleButton || this.actionBtnTarget,
        this.sendBtnTarget,
      );
      this.currentVisibleButton = this.sendBtnTarget;
    } else {
      this.switchBtnsAfterClearingInputFeild();
    }
  }

  switchBtnsAfterClearingInputFeild() {
    if (this.currentVisibleButton === this.actionBtnTarget) return;
    this.switchButtons(
      this.currentVisibleButton || this.sendBtnTarget,
      this.actionBtnTarget,
    );
    this.currentVisibleButton = this.actionBtnTarget;
  }

  switchButtons(hideButton, showButton) {
    const animationOptions = {
      duration: 250,
      easing: "cubic-bezier(0.4, 0, 0.2, 1)",
    };

    // Animate out the button to hide
    hideButton.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      animationOptions,
    ).onfinish = () => {
      // Hide the outgoing button
      hideButton.classList.add("d-none");
      if (hideButton === this.sendBtnTarget) {
        hideButton.classList.remove("d-flex");
      }

      // Now show and animate in the new button
      showButton.classList.remove("d-none");
      if (showButton === this.sendBtnTarget) {
        showButton.classList.add("d-flex");
      }

      // Animate in immediately after hiding the previous button
      showButton.animate([{ opacity: 0 }, { opacity: 1 }], animationOptions);
    };
  }

  updateVisibleCollapseIcon() {
    const collapseDivs = document.querySelectorAll(".collapse");

    collapseDivs.forEach((div) => {
      if (!div.id.startsWith("collapse")) return;

      const section = div.id.substring("collapse".length);
      const icon = document.getElementById(`icon${section}`);

      if (!icon) return;

      const rotation = div.classList.contains("show")
        ? "rotate(180deg)"
        : "rotate(0deg)";
      icon.style.transform = rotation;
    });
  }

  toggle(event) {
    event.preventDefault();

    // Delay icon update to allow Bootstrap's collapse animation to finish
    setTimeout(() => {
      this.updateVisibleCollapseIcon();
    }, 400);
  }

  handleAfterSubmit() {
    this.inputTarget.value = "";
    this.switchBtnsAfterClearingInputFeild();

    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  handleModalSubmit(event) {
    if (!event.detail.success) return;

    const modal = document.querySelector(".modal.show");
    if (modal) {
      $(modal).modal("hide");
      $(".modal-backdrop").remove();

      // find the form inside the modal and reset it
      const form = modal.querySelector("form");
      if (form) form.reset();

      // enable the file inuput fields after resetting the form
      const attachmentFileInput = document.getElementById("attach_file_input");
      if (attachmentFileInput) attachmentFileInput.disabled = false;
      const InvoiceFileInput = document.getElementById(
        "attach_locked_file_input",
      );
      if (InvoiceFileInput) InvoiceFileInput.disabled = false;
    }

    // hide the progress bar after submit
    const progressBar = document.querySelector(".direct-upload--complete");
    if (progressBar) progressBar.hidden = true;

    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  clearPriceFields() {
    const subTotals = document.querySelectorAll(".total-price");
    if (subTotals.length > 0) {
      subTotals.forEach((item) => {
        item.textContent = "";
      });
    }

    const total = document.querySelector(".total-amount-currency");
    if (total) total.textContent = "";
  }
}
